import _ from "lodash";
import Api from "../../../lib/api";
import { setMessage } from "../notification/slice";
import { singular } from "../../../utils/stringUtils";

export function editEntity(
    entityObject,
    updatedData,
    editEntityAction,
    editEntitySuccessAction,
    editEntityFailureAction
) {
    return async (dispatch) => {
        dispatch(editEntityAction());
        try {
            const response = await Api.put(`/${entityObject.type}/${entityObject.id}`, {
                data: {
                    id: +entityObject.id,
                    type: entityObject.type,
                    attributes: {
                        ...updatedData,
                    },
                },
            });
            dispatch(editEntitySuccessAction({ ...response }));
            dispatch(
                setMessage({
                    content: `Updated ${_.startCase(singular(entityObject.type))}`,
                    isError: false,
                })
            );
        } catch (error) {
            dispatch(editEntityFailureAction({ error }));
            dispatch(
                setMessage({
                    content: error,
                    title: `Couldn't update ${_.startCase(singular(entityObject.type))}`,
                    isError: true,
                })
            );
            throw error;
        }
    };
}

export const createEntity = async (entityName, attributes) => {
    try {
        const response = await Api.post(`/${entityName}`, {
            data: {
                type: entityName,
                attributes,
            },
        });
        return response;
    } catch (error) {
        throw new Error(`Error adding ${entityName} \n Error message: ${error.message}`);
    }
};

export const getEntity = async (entityName, id) => {
    try {
        const response = await Api.get(`/${entityName}/${id}`);
        return response;
    } catch (err) {
        throw err;
    }
};

export const deleteSingleAttachment = async (id) => {
    try {
        const response = await Api.delete(`attachments/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
};
export const deletePaymentMethod = async (id) => {
    try {
        const response = await Api.delete(`payment-methods/${id}`);
    } catch (error) {
        throw error;
    }
};
